import { EpgUtil } from '../../utility/EpgUtil';
import { ErrorTranslationKeys } from '../../../api/models/TranslationKeys';
import { ProgramDetailDataSource } from './ProgramDetailDataSource';
import { EpgDetailDataSource } from './EpgDetailDataSource';
import { IDetailModel } from '../detail.types';
import { EpgApiV5 } from '../../../api/EpgApiV5';

export class ChannelDetailDataSource extends EpgDetailDataSource {
  private programDS: ProgramDetailDataSource | undefined;

  override load(channelId: string): Promise<IDetailModel | undefined> {
    return this.initChannels().then(() => {
      this.channel = this.channelsList?.find(channel => channel.channelId === channelId);
      if (!this.channel) {
        return;
      }

      //todo check adult

      const fromuntil = EpgUtil.getTodayFromUntil();
      return EpgApiV5.channelLineup(this.backend, channelId, fromuntil.from, fromuntil.until).then(result => {
        const schedule = EpgUtil.findCurrentSchedule(result.schedules);
        if (!schedule) {
          throw new Error(this.backend.translations.forKey(ErrorTranslationKeys.error_load_details));
        }

        //todo check adult
        this.programDS = new ProgramDetailDataSource(this.backend, schedule);
        return this.programDS.load(schedule.programId);
      });
    });
  }
}
